export default __webpack_public_path__ + "static/view-f89c1273bd7105aa735f7176ac18e111.jpg";